import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const legacyOrdersDeliveryAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.OrdersDelivery],
  },
  // Access control for only J&T (3rd party contractor) to access Delivery orders
  {
    permissions: [Permission.OrdersDelivery],
    featureToggles: [FeatureToggle.LegacyOrdersRestrictedAccess],
    restrictedBannersAllowed: true,
  },
]

export const legacyOrdersPickupAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.OrdersPickup],
  },
  // Access control for only J&T (3rd party contractor) to access Pickup orders
  {
    permissions: [Permission.OrdersPickup],
    featureToggles: [FeatureToggle.LegacyOrdersRestrictedAccess],
    restrictedBannersAllowed: true,
  },
]
